import { render, staticRenderFns } from "./VideoAiConfig.vue?vue&type=template&id=c7c6a2c4&scoped=true"
import script from "./VideoAiConfig.vue?vue&type=script&lang=js"
export * from "./VideoAiConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7c6a2c4",
  null
  
)

export default component.exports